import {React,useState,useEffect} from 'react';
import GenericDropdown from '../Dropdowns/GenericDropdown.js';
import GetMonthsOpt from '../Dropdowns/getSelectMonth.js';
import GetYearsOpt from '../Dropdowns/getSelectYear.js';
import axios from 'axios';
import StateWiseCommission from './StateWiseCommission.jsx';

const MonthWiseStateCommission = () => {

const [loading, setLoading] = useState(true);
const [userRole, setUserRole] = useState('');
const [district, setDistrict] = useState('');
const [districts, setDistricts] = useState([]);
const [distCode, setDistCode] = useState('0'); 
const [userName, setUserName] = useState('');
const [sessionExpired, setSessionExpired] = useState(false);
const [sessionLoading, setSessionLoading] = useState(true);  
const [bankType, setBankType] = useState('0'); 
const [renderContent, setRenderContent] = useState(null);

const bankTypeNames = {
          '0': 'ALL',
          'DCR': 'SBI',
          'NEFT': 'Non-SBI'
  };

useEffect(() => {
  axios
      .get(`${process.env.REACT_APP_URL}/api/ekyc-abstract/session-info`, {
        withCredentials: true,
      })
      .then(res => {          
          setUserRole(res.data.userRole || '0'); 
          setUserName(res.data.loginUserName);          
          setSessionExpired(false);       
      })
      .catch(err => {
        setSessionExpired(true);
        setUserRole('0');
      })
      .finally(() => {        
        setSessionLoading(false); 
      });

  axios.get(`${process.env.REACT_APP_URL}/api/fps/districts`).then(res => {
    setDistricts(res.data);      
  });

  }, []);

  //  useEffect(() => {
  //     if (userRole === '2' && userName && districts.length > 0) {
  //       // Find district where dist_name_en matches userName (case-insensitive)
  //       const matchedDistrict = districts.find(
  //         (d) => d.dist_name_en.toLowerCase() === userName.toLowerCase()
  //       );
    
  //       if (matchedDistrict) {
  //         setDistCode(matchedDistrict.dist_code);
  //         setDistrict(matchedDistrict.dist_name_en);
  //       } else {
  //         setDistCode('0');
  //         setDistrict('ALL');
  //       }
  //     }
  //   }, [userRole, userName, districts]);

   useEffect(() => {
  if (userRole !== "2" || !districts) return;

  const districtList = Array.isArray(districts) ? districts : [districts];

  if (districtList.length === 1) {
    const { dist_code, dist_name } = districtList[0];
    setDistCode(dist_code);
    setDistrict(dist_name);
  }
}, [userRole, districts]);

  const handleChange = (e) => {
  };

  const handleLoadingChange = (isLoading) => {
      setLoading(isLoading);
  };    

  const handleMonthsLoadingChange = (isLoading) => {
      handleLoadingChange(isLoading);
  };

  const handleYearsLoadingChange = (isLoading) => {
      handleLoadingChange(isLoading);
  }; 

  const buildReportTitle = () => {
  const monthVal = document.getElementById('month')?.value || '';
  const yearVal = document.getElementById('year')?.value || '';
  const allotMonthVal = document.getElementById('allot_month')?.value || '';
  const allotYearVal = document.getElementById('allot_year')?.value || '';

  const distMonthName = document.getElementById("month").options[document.getElementById("month").selectedIndex].text; 
  const alotMonthName = document.getElementById("allot_month").options[document.getElementById("allot_month").selectedIndex].text;      
  const commName = document.getElementById("comm_id").options[document.getElementById("comm_id").selectedIndex].text;
  
  const distributionMonth = distMonthName || '';
  const distributionYear = yearVal || '';
  const allottedMonth = alotMonthName || '';
  const allottedYear = allotYearVal || '';
  const commodityDisplay = commName || '';
  const bankDisplay = bankTypeNames[bankType] || '';
  const districtName = district || 'ALL';  

  return `State Commission Report for Distribution: ${distributionMonth}'${distributionYear} , Allotment: ${allottedMonth}'${allottedYear} ,District: ${districtName}, Commodity: ${commodityDisplay} and Bank Type: ${bankDisplay}`;
  };

  const handleSubmit =  async () => {      

      const month = document.getElementById('month').value;
      const year = document.getElementById('year').value;
      const allot_month = document.getElementById('allot_month').value;
      const allot_year = document.getElementById('allot_year').value;
      const comm_id = document.getElementById('comm_id').value;      
      

      if ( month == null || month ==''  ) { 
          alert('Please select Distribution Month');
          return false;
      } else  if ( year == null || year ==''  ) {
          alert('Please select Distribution Year');
          return false;
      }else  if ( allot_month == null || allot_month ==''  ) { 
          alert('Please select Allotted Month');
           return false;
      } else  if ( allot_year == null || allot_year ==''  ) { 
          alert('Please select Allotted Year');
           return false;
      } else  if ( comm_id == null || comm_id ==''  ) {
          alert('Please select Commodity');
          return false;
      }else {
            setRenderContent(null);

            const title = buildReportTitle();       
            
            setRenderContent(
                <StateWiseCommission 
                    month={month} 
                    year={year} 
                    allotMonth={allot_month} 
                    allotYear={allot_year} 
                    commId={comm_id} 
                    distCode={distCode}
                    bankType={bankType}  
                    reportTitle={title}                 
                    />
            );
            
       }
      
  };

  

  return (
    <div className="wrapper row3" style={{   paddingBottom: '40px' }}>
    <div id="container">
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
     <table width="55%">
     <thead>
        <tr className="tableheader">
        <th colSpan={14}>Month Wise State Commission</th>
        </tr>
    </thead>  
    <tbody>
        <tr>
            <td>Distribution Month	:</td>
            <td><GetMonthsOpt input_id = 'month'  onLoadingChange={handleMonthsLoadingChange}/></td>
            <td>Distribution Year:</td>
            <td><GetYearsOpt input_id = 'year'  onLoadingChange={handleYearsLoadingChange}/></td>
            <td>Allotted Month	:</td>
            <td><GetMonthsOpt input_id = 'allot_month'  onLoadingChange={handleMonthsLoadingChange}/></td>
            <td>Allotted Year:</td>
            <td><GetYearsOpt input_id = 'allot_year'  onLoadingChange={handleYearsLoadingChange}/></td> 
            <td><b>District</b></td>
            <td>
              {(userRole === '1' || userRole === '9' || userRole === '10') ? (
                <select
                  value={distCode}
                  onChange={(e) => {
                    const selectedCode = e.target.value;
                    setDistCode(selectedCode);
                    const match = districts.find(d => d.dist_code === selectedCode);
                    setDistrict(selectedCode === '0' || selectedCode === '' ? 'ALL' : (match ? match.dist_name_en : ''));
                  }}
                >
                  <option value="0">ALL</option>
                  {districts.map((d, idx) => (
                    <option key={idx} value={d.dist_code}>{d.dist_name_en}</option>
                  ))}
                </select>
              ) : userRole === '2' ? (
                <>
                <input type="hidden" name="distCode" id="dist_code" value={distCode} />
                <div>{userName}</div>
                </>
              ) : (
                <span>N/A</span> // fallback for other roles
              )}
            </td>
             <td>Commodity</td>
            <td>
              <GenericDropdown
              tab="common.commodity_master"
              code="comm_id"
              name="comm_name_en"
              whfld="status"
              whval="A"
              whfld1="nfsa_comm"
              whval1="S"
              dropdownName="comm_name"
              dropdownId="comm_id"
              JSONKey="id"
              JSONValue="name"
              onChange={handleChange}
            />
            </td>
            <td>Bank Type</td>
            <td>
                <select  name="bankType" id="bankType"  value={bankType} onChange={(e) => setBankType(e.target.value)}>
                <option value="0">ALL</option>
                <option value="DCR">SBI</option>
                <option value="NEFT">Non-SBI</option>
                </select>  
            </td>    
        </tr>
        <tr >
        <td colSpan="14" align="center">
            {<button className="button button2"  style={{ marginRight: '10px' }} onClick={handleSubmit}>Submit</button> }
            <button className="button button2" onClick={() => window.history.back()}>Back</button>
        </td>
        </tr>
    </tbody>  
    </table>
    </div>

     <br />
        <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
            <img src="images/progress.gif" alt="Loading" />
        </div>
        <br />           
        <div id="detailsStateCommission">{renderContent}</div>
    </div>  
     <br/>
     <br/>   
   
    </div> 

   
   
  );
};

export default MonthWiseStateCommission;
